import * as yup from 'yup';
import { TFunction } from 'i18next';
import { MAX_TAGS } from '../../constants';
import { FieldValidator } from '../../types';

export const validator: FieldValidator = (_, t: TFunction) =>
  yup.object({
    tags: yup
      .array()
      .of(yup.string())
      .max(MAX_TAGS, t('deviationSubmit.validation.error.tags.max', { max: MAX_TAGS })),
  });
